import React from 'react';

import PropTypes from 'prop-types';

import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { Stories } from 'apps/auth/components/common/Layout/Stories/Stories';
import StoryLayout from 'apps/auth/components/common/Layout/Stories/StoryLayout';
import { AUTH_SEND_LINK } from 'apps/auth/constants/UrlConstants';
import { usePageMessages } from 'apps/auth/hooks/selectors';
import usePreloadStoryImages from 'apps/auth/hooks/usePreloadStoryImages';

const FirstTimeTransferStories = (props) => {
    const { notNowButton, newTransaction } = usePageMessages();
    const slides = props.sliders?.slides;
    const duration = props.sliders?.duration * 1000;
    const imagesLoaded = usePreloadStoryImages(slides);

    const getSteps = () => {
        let steps = [];
        if (slides) {
            steps = slides.map((slide) => {
                return (
                    <StoryLayout
                        key={slide.order}
                        topButtonCaption={props.hasTopButton ? notNowButton : null}
                        onTopButtonClick={() => {
                            props.popupFullwidthRef.current?.close();
                        }}
                        title={slide.title}
                        subtitle={<DangerouslyHtml dangerouslyHtml={slide.subtitle} />}
                        imgA={slide.web_a_bg_img_url}
                        imgA2x={slide.web_a2x_bg_img_url}
                        bottomButtonCaption={newTransaction}
                        contentPosition={slide.position}
                        href={AUTH_SEND_LINK}
                        onBottomButtonClick={props.checkRestrictions}
                        variant="secondary_base"
                    />
                );
            });
        }
        return steps;
    };

    return <>{imagesLoaded && <Stories steps={getSteps()} isInverted infinityLoop duration={duration} />}</>;
};

FirstTimeTransferStories.propTypes = {
    sliders: PropTypes.object,
    popupFullwidthRef: PropTypes.shape({ current: PropTypes.object }),
    checkRestrictions: PropTypes.func,
};
export default FirstTimeTransferStories;
